export default __webpack_public_path__ + "static/media/delete.5c26c5a4.svg";